import React from "react";

function PopupTextBlock({
  block,
  updateBlock,
  removeBlock
}) {

  return (

    <div className="popup-block">

      <textarea
        placeholder="Votre texte..."
        value={block.content}
        onChange={(e)=>
          updateBlock(
            block.id,
            "content",
            e.target.value
          )
        }
      />

      <input
        type="color"
        value={block.color}
        onChange={(e)=>
          updateBlock(
            block.id,
            "color",
            e.target.value
          )
        }
      />

      <input
        type="number"
        min="10"
        max="60"
        value={block.fontSize}
        onChange={(e)=>
          updateBlock(
            block.id,
            "fontSize",
            e.target.value
          )
        }
      />

      <select
        value={block.textAlign}
        onChange={(e)=>
          updateBlock(
            block.id,
            "textAlign",
            e.target.value
          )
        }
      >
        <option value="left">
          Gauche
        </option>

        <option value="center">
          Centre
        </option>

        <option value="right">
          Droite
        </option>

      </select>

      <button
        className="remove-block-btn"
        onClick={() =>
          removeBlock(block.id)
        }
      >
        ❌ Supprimer
      </button>

    </div>

  );

}

export default PopupTextBlock;